import { dataHooks } from '@wix/data-hooks'

export const storesFunnelChooseTemplateDataHooks = dataHooks<{
  back: {}
  skip: {}
  next: {}
  stepProgressBar: {}
  title: {}
  templateItem: { key: string }
  templatePreview: { key: string }
  templateImage: { key: string }
  templateTitle: { key: string }
  templateDescription: { key: string }
  previewButton: { key: string }
  chooseTemplateButton: {}
  modalBack: {}
  modalChoose: {}
  iframe: {}
}>('stores-funnel-choose-template')
